export default function ({ redirect, app }) {
  return redirect(app.localePath('cart'))
}
